import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
	selector: 'fn-grid-column-pin-filter',
	templateUrl: './fn-grid-column-pin-filter.component.html',
	styleUrls: ['./fn-grid-column-pin-filter.component.scss'],
})
export class FnGridColumnPinFilterComponent implements OnInit {
	constructor() {}
	@Input() pinTo: string;
	@Output() callback = new EventEmitter<any>();
	selectedPosition = '';
	pinToArray = [
		{
			name: 'Left',
			id: 'left',
		},
		{
			name: 'Right',
			id: 'right',
		},
		{
			name: 'None',
			id: 'none',
		},
	];

	@Input() field: string;
	ngOnInit(): void {
		this.selectedPosition = this.field + (this.pinTo ? this.pinTo : 'none');
	}
	pinColumn(pinTo: string) {
		this.callback.emit({
			type: 'pinTo',
			pinTo,
		});
	}
	reset() {
		this.callback.emit({
			type: 'resetAll',
		});
	}
}
